// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getImageEditorData } from '../imageModalUtils';

// Components
import ImageModalToolbarSecondaryTools from './ImageModalToolbarSecondaryTools';

// Styles
import './ImageModalUploadToolbar.scss';
import { useTranslator } from '../../../../components/i18n/useTranslator';

const ImageModalUploadToolbar = (props) => {
    const { element } = props;
    const translate = useTranslator('popup', 'imageModal.upload');

    return (
        <ImageModalToolbarSecondaryTools className="ImageModalUploadToolbar">
            {!!getImageEditorData(element) ? (
                <>
                    {translate('savingChanges', 'Saving changes')}
                    …
                </>
            ) : (
                <>
                    {translate('uploadingImage', 'Uploading image')}
                    …
                </>
            )}
        </ImageModalToolbarSecondaryTools>
    );
};

ImageModalUploadToolbar.propTypes = {
    element: PropTypes.object,
};

export default ImageModalUploadToolbar;
